import { useContext } from 'react';
import { useCartAdd } from 'src/hooks/useCartAdd';
import { useModal } from 'src/hooks/useModal';
import { useShopPickupDeadline } from 'src/hooks/useShopPickupDeadline';
import { I18nContext } from 'src/stores/I18n';
import { Presenter } from './Presenter';

export const LimitedSaleProductModal = () => {
  const { isVisible, setIsVisible, modalParams, setModalParams } = useModal('limitedSaleProductModal');
  const localeResources = useContext(I18nContext);
  const { onAddToCart } = useCartAdd({ targetAttributionToken: modalParams.extraData?.targetAttributionToken });
  const pickupDeadline = useShopPickupDeadline(modalParams.product?.shopProducts);
  const onClick = () => {
    if (modalParams.product && modalParams.quantity) {
      onAddToCart(modalParams.product, modalParams.quantity, 'limited_sale_product_modal');
      setIsVisible(false);
    }
  };

  const closeModal = () => {
    setModalParams({
      type: 'info'
    });
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <Presenter
      pickupDeadline={pickupDeadline}
      localeResources={localeResources}
      onClick={onClick}
      closeModal={closeModal}
    />
  );
};
